<div
  class="hover-container"
  (mouseover)="onMouseover()"
  (mouseout)="onMouseout()"
  [class.use-as-result-item]="useAsResultItem"
  [class.hovered]="hovered"
>
  <div class="main" [class.show-link-name]="showLinkName()">
    <div class="icon-container">
      <u-icon
        *ngIf="model()?.view?.icon"
        [ngClass]="{ 'with-icon-overlay': model()?.view?.iconOverlay }"
        [model]="iconModel"
        [fallback]="fallbackIcon()"
      ></u-icon>
      <ng-container *ngIf="!isIconOverlayEmoji; else overlayEmoji">
        <u-icon *ngIf="model()?.view?.iconOverlay" class="icon-overlay" [model]="iconOverlayModel"></u-icon>
      </ng-container>
      <ng-template #overlayEmoji>
        <u-icon *ngIf="model()?.view?.iconOverlay" iconCtx="url" [model]="iconOverlayModel" class="icon-overlay"></u-icon>
      </ng-template>
      @if (showLinkName()) {
        <div class="link-name">{{ model()?.view?.linkName }}</div>
      }
    </div>
    <div class="hover-data">
      <div class="hover-name" *ngIf="model()?.view?.title?.text">
        <div class="title-container" [class.has-sub-title]="model()?.view?.subtitle?.text">
          <span
            class="hover-title"
            [innerHTML]="model().view.title.text | removeNewLine | richTextFormatted"
            (click)="openResource()"
            #mainTitle
            (mouseenter)="updateMainTitleTooltip(mainTitle)"
            [tooltipDisabled]="!useAsResultItem || mainTitleTooltipDisabled()"
            [pTooltip]="model().view.title.text | richTextFormatted"
            tooltipPosition="bottom"
            tooltipStyleClass="u-tooltip"
          >
          </span>
          @if (model().resource?.data.verificationStatus) {
            <u-icon
              class="verification-status"
              [model]="{
                type: 'img',
                value: {
                  lightUrl:
                    model().resource?.data.verificationStatus === 'Verified'
                      ? './assets/verification/verified-light.svg'
                      : './assets/verification/unverified-light.svg',
                },
              }"
            >
            </u-icon>
          }
        </div>
        @if (model()?.view?.subtitle?.text) {
          <div
            class="hover-subtitle"
            #subTitleElement
            (mouseenter)="updateSubTitleTooltip(subTitleElement)"
            [tooltipDisabled]="!useAsResultItem || subTitleTooltipDisabled()"
            [pTooltip]="model().view.subtitle.text"
            tooltipPosition="bottom"
            tooltipStyleClass="u-tooltip"
          >
            {{ model().view.subtitle.text }}
          </div>
        }
        <div class="hover-bullet">
          @if (bulletIconModel) {
            <u-icon data-cy="result-bullet-icon" class="bullet-icon undraggable" [model]="bulletIconModel"></u-icon>
          }
          @if (modifiedAt) {
            <div>{{updatePrefix}} {{ modifiedBy || createdBy }} {{ modifiedAt }}</div>
          } @else if (createAt) {
            <div>Created {{ createdBy }} {{ createAt }}</div>
          } @else {
            <div *ngIf="modifiedBy">{{updatePrefix}} {{ modifiedBy }}</div>
            <div *ngIf="!modifiedBy && createdBy">Created {{ createdBy }}</div>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="actions" *ngIf="useAsResultItem && !isExtension">
    <u-icon
      *ngIf="hasSummary"
      class="indicate-summary"
      (click)="onSummary($event, summaryResourceId)"
      [model]="INDICATE_SUMMARY_ICON"
      pTooltip="Show summary"
      tooltipPosition="top"
      tooltipStyleClass="u-tooltip"
    ></u-icon>

    <square-button
      class="context-menu"
      data-cy="search-results-actions-kebab"
      click-invoker
      (click)="$event.stopPropagation(); openContextMenu($event)"
      (auxclick)="$event.stopPropagation(); openContextMenu($event)"
      (contextmenu)="$event.stopPropagation(); openContextMenu($event)"
      #actions
      >•••</square-button
    >
  </div>
</div>
